export default "__VITE_PUBLIC_ASSET__16381b65__"